import { Component, computed, input } from '@angular/core';
import { CardComponent } from '../../../../components/card/card.component';
import { FeedbackStatistic } from '@shared/interfaces/feedback';
import { RouterModule } from '@angular/router';
import { MetricCardComponent, MetricCardData } from '../../../../components/metric-card/metric-card.component';

@Component({
  selector: 'app-feedback-responses',
  imports: [CardComponent, RouterModule, MetricCardComponent],
  templateUrl: './feedback-responses.component.html',
  styleUrl: './feedback-responses.component.css',
})
export class FeedbackResponsesComponent {
  public feedback = input<FeedbackStatistic[]>();
  protected cards = computed<MetricCardData[]>(() =>
    (this.feedback() || []).map((feedback) => {
      const isGeneral = feedback.feature === 'general';
      return {
        title: feedback.feature,
        subtitle: isGeneral
          ? $localize`Received via homepage dialogue or the Feedback button on every page.`
          : $localize`Survey responses`,
        count: feedback.count,
        countTitle: isGeneral ? $localize`Comments` : $localize`Total responses`,
        countSubtitle: $localize`(+${feedback.recentCount} last 7 days)`,
        link: feedback.feature,
        linkLabel: isGeneral ? $localize`See comments` : $localize`See responses`,
        rating: feedback.rating,
      };
    }),
  );
}
